import React from 'react';
import { sceneImages } from '../../data/images';
import { useShopNavigation } from '../../hooks/useShopNavigation';
import { buttonClasses } from '../../utils/buttonStyles';
export function ClosingCta() {
  const shop = useShopNavigation();
  return <section aria-labelledby="closing-title" className="relative overflow-hidden" data-id="element-215" data-mp="e2h9p86vw4g8">
      <img src={sceneImages.waterTexture} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-216" data-mp="j23kzc35jame" />
      <div className="absolute inset-0 bg-deep/75" aria-hidden data-id="element-217" data-mp="452v7e4itpqk" />
      <div className="relative mx-auto flex max-w-site flex-col items-center gap-4 px-5 py-6 text-center md:flex-row md:justify-between md:gap-8 md:px-8 md:py-7 md:text-left" data-id="element-218" data-mp="96jtd1vmey3g">
        <div data-id="element-219" data-mp="4akegg03cs6">
          <p className="font-display text-sm uppercase tracking-[0.2em] text-ice md:text-base" data-id="element-220" data-mp="40vyxaltdol">Anything. Anytime. Anywhere.</p>
          <h2 id="closing-title" className="mt-1 font-display text-3xl font-semibold uppercase leading-[0.95] md:text-5xl" data-id="element-221" data-mp="1pk9z0d2e1uf7">
            One set installed. One set ready.
          </h2>
        </div>
        <button type="button" onClick={() => shop()} className={`${buttonClasses('primary', 'lg')} w-full shrink-0 sm:w-auto`} data-id="element-222" data-mp="1pfg4z37amq19">
          Choose your system
        </button>
      </div>
    </section>;
}